module.exports = "/_next/static/images/boosts-hero-mobile-b84def75fda15ca51ac9b8d9f3c424d0.svg";